import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Card,
  Alert,
} from "react-bootstrap";
import SimpleHeader from "components/Headers/SimpleHeader";
import { ThemeContext } from "contexts/ThemeContext.jsx";
import HusariaSelect from "components/HusariaSelect.js";
import { serverHost } from "variables/serverdata.js";

const REGIONS = {
  Europe: [
    "AL", "AD", "AT", "BY", "BE", "BA", "BG", "HR", "CY", "CZ", "DK", "EE",
    "FI", "FR", "DE", "GR", "HU", "IS", "IE", "IT", "LV", "LI", "LT", "LU",
    "MT", "MD", "MC", "ME", "NL", "MK", "NO", "PL", "PT", "RO", "RU", "SM",
    "RS", "SK", "SI", "ES", "SE", "CH", "UA", "GB",
  ],
  "Latin America": [
    "MX", "GT", "BZ", "HN", "SV", "NI", "CR", "PA",
    "CO", "VE", "GY", "SR", "BR", "EC", "PE", "BO", "PY", "CL", "UY", "AR",
  ],
  Asia: [
    "AF", "AM", "AZ", "BH", "BD", "BT", "BN", "KH", "CN", "CY", "GE", "IN",
    "ID", "IR", "IQ", "IL", "JP", "JO", "KZ", "KW", "KG", "LA", "LB", "MY",
    "MV", "MN", "MM", "NP", "KP", "OM", "PK", "PH", "QA", "SA", "SG", "KR",
    "LK", "SY", "TW", "TJ", "TH", "TL", "TM", "AE", "UZ", "VN", "YE",
  ],
  Africa: [
    "DZ", "AO", "BJ", "BW", "BF", "BI", "CV", "CM", "CF", "TD", "KM", "CG",
    "DJ", "EG", "GQ", "ER", "ET", "GA", "GM", "GH", "GN", "GW", "KE", "LS",
    "LR", "LY", "MG", "MW", "ML", "MR", "MU", "MA", "MZ", "NA", "NE", "NG",
    "RW", "ST", "SN", "SC", "SL", "SO", "ZA", "SS", "SD", "SZ", "TZ", "TG",
    "TN", "UG", "ZM", "ZW",
  ],
  Oceania: [
    "AU", "FJ", "KI", "MH", "FM", "NR", "NZ", "PW", "PG", "WS", "SB", "TO", "TV", "VU",
  ],
  "South America": [
    "AR", "BO", "BR", "CL", "CO", "EC", "GY", "PY", "PE", "SR", "UY", "VE",
  ],
};

const COUNTRIES = [
  { value: "AF", label: "Afghanistan" },
  { value: "AL", label: "Albania" },
  { value: "DZ", label: "Algeria" },
  { value: "AD", label: "Andorra" },
  { value: "AO", label: "Angola" },
  { value: "AR", label: "Argentina" },
  { value: "AM", label: "Armenia" },
  { value: "AU", label: "Australia" },
  { value: "AT", label: "Austria" },
  { value: "AZ", label: "Azerbaijan" },
  { value: "BH", label: "Bahrain" },
  { value: "BD", label: "Bangladesh" },
  { value: "BY", label: "Belarus" },
  { value: "BE", label: "Belgium" },
  { value: "BZ", label: "Belize" },
  { value: "BJ", label: "Benin" },
  { value: "BT", label: "Bhutan" },
  { value: "BO", label: "Bolivia" },
  { value: "BA", label: "Bosnia and Herzegovina" },
  { value: "BW", label: "Botswana" },
  { value: "BR", label: "Brazil" },
  { value: "BN", label: "Brunei" },
  { value: "BG", label: "Bulgaria" },
  { value: "BF", label: "Burkina Faso" },
  { value: "BI", label: "Burundi" },
  { value: "CV", label: "Cabo Verde" },
  { value: "KH", label: "Cambodia" },
  { value: "CM", label: "Cameroon" },
  { value: "CF", label: "Central African Republic" },
  { value: "TD", label: "Chad" },
  { value: "CL", label: "Chile" },
  { value: "CN", label: "China" },
  { value: "CO", label: "Colombia" },
  { value: "KM", label: "Comoros" },
  { value: "CG", label: "Congo" },
  { value: "CR", label: "Costa Rica" },
  { value: "HR", label: "Croatia" },
  { value: "CY", label: "Cyprus" },
  { value: "CZ", label: "Czech Republic" },
  { value: "DK", label: "Denmark" },
  { value: "DJ", label: "Djibouti" },
  { value: "EC", label: "Ecuador" },
  { value: "EG", label: "Egypt" },
  { value: "SV", label: "El Salvador" },
  { value: "GQ", label: "Equatorial Guinea" },
  { value: "ER", label: "Eritrea" },
  { value: "EE", label: "Estonia" },
  { value: "SZ", label: "Eswatini" },
  { value: "ET", label: "Ethiopia" },
  { value: "FJ", label: "Fiji" },
  { value: "FI", label: "Finland" },
  { value: "FR", label: "France" },
  { value: "GA", label: "Gabon" },
  { value: "GM", label: "Gambia" },
  { value: "GE", label: "Georgia" },
  { value: "DE", label: "Germany" },
  { value: "GH", label: "Ghana" },
  { value: "GR", label: "Greece" },
  { value: "GT", label: "Guatemala" },
  { value: "GN", label: "Guinea" },
  { value: "GW", label: "Guinea-Bissau" },
  { value: "GY", label: "Guyana" },
  { value: "HN", label: "Honduras" },
  { value: "HU", label: "Hungary" },
  { value: "IS", label: "Iceland" },
  { value: "IN", label: "India" },
  { value: "ID", label: "Indonesia" },
  { value: "IR", label: "Iran" },
  { value: "IQ", label: "Iraq" },
  { value: "IE", label: "Ireland" },
  { value: "IL", label: "Israel" },
  { value: "IT", label: "Italy" },
  { value: "JP", label: "Japan" },
  { value: "JO", label: "Jordan" },
  { value: "KZ", label: "Kazakhstan" },
  { value: "KE", label: "Kenya" },
  { value: "KI", label: "Kiribati" },
  { value: "KW", label: "Kuwait" },
  { value: "KG", label: "Kyrgyzstan" },
  { value: "LA", label: "Laos" },
  { value: "LV", label: "Latvia" },
  { value: "LB", label: "Lebanon" },
  { value: "LS", label: "Lesotho" },
  { value: "LR", label: "Liberia" },
  { value: "LY", label: "Libya" },
  { value: "LI", label: "Liechtenstein" },
  { value: "LT", label: "Lithuania" },
  { value: "LU", label: "Luxembourg" },
  { value: "MG", label: "Madagascar" },
  { value: "MW", label: "Malawi" },
  { value: "MY", label: "Malaysia" },
  { value: "MV", label: "Maldives" },
  { value: "ML", label: "Mali" },
  { value: "MT", label: "Malta" },
  { value: "MH", label: "Marshall Islands" },
  { value: "MR", label: "Mauritania" },
  { value: "MU", label: "Mauritius" },
  { value: "MX", label: "Mexico" },
  { value: "FM", label: "Micronesia" },
  { value: "MD", label: "Moldova" },
  { value: "MC", label: "Monaco" },
  { value: "MN", label: "Mongolia" },
  { value: "ME", label: "Montenegro" },
  { value: "MA", label: "Morocco" },
  { value: "MZ", label: "Mozambique" },
  { value: "MM", label: "Myanmar" },
  { value: "NA", label: "Namibia" },
  { value: "NR", label: "Nauru" },
  { value: "NP", label: "Nepal" },
  { value: "NL", label: "Netherlands" },
  { value: "NZ", label: "New Zealand" },
  { value: "NI", label: "Nicaragua" },
  { value: "NE", label: "Niger" },
  { value: "NG", label: "Nigeria" },
  { value: "KP", label: "North Korea" },
  { value: "MK", label: "North Macedonia" },
  { value: "NO", label: "Norway" },
  { value: "OM", label: "Oman" },
  { value: "PK", label: "Pakistan" },
  { value: "PW", label: "Palau" },
  { value: "PA", label: "Panama" },
  { value: "PG", label: "Papua New Guinea" },
  { value: "PY", label: "Paraguay" },
  { value: "PE", label: "Peru" },
  { value: "PH", label: "Philippines" },
  { value: "PL", label: "Poland" },
  { value: "PT", label: "Portugal" },
  { value: "QA", label: "Qatar" },
  { value: "RO", label: "Romania" },
  { value: "RU", label: "Russia" },
  { value: "RW", label: "Rwanda" },
  { value: "WS", label: "Samoa" },
  { value: "SM", label: "San Marino" },
  { value: "ST", label: "Sao Tome and Principe" },
  { value: "SA", label: "Saudi Arabia" },
  { value: "SN", label: "Senegal" },
  { value: "RS", label: "Serbia" },
  { value: "SC", label: "Seychelles" },
  { value: "SL", label: "Sierra Leone" },
  { value: "SG", label: "Singapore" },
  { value: "SK", label: "Slovakia" },
  { value: "SI", label: "Slovenia" },
  { value: "SB", label: "Solomon Islands" },
  { value: "SO", label: "Somalia" },
  { value: "ZA", label: "South Africa" },
  { value: "KR", label: "South Korea" },
  { value: "SS", label: "South Sudan" },
  { value: "ES", label: "Spain" },
  { value: "LK", label: "Sri Lanka" },
  { value: "SD", label: "Sudan" },
  { value: "SR", label: "Suriname" },
  { value: "SE", label: "Sweden" },
  { value: "CH", label: "Switzerland" },
  { value: "SY", label: "Syria" },
  { value: "TW", label: "Taiwan" },
  { value: "TJ", label: "Tajikistan" },
  { value: "TZ", label: "Tanzania" },
  { value: "TH", label: "Thailand" },
  { value: "TL", label: "Timor-Leste" },
  { value: "TG", label: "Togo" },
  { value: "TO", label: "Tonga" },
  { value: "TN", label: "Tunisia" },
  { value: "TR", label: "Turkey" },
  { value: "TM", label: "Turkmenistan" },
  { value: "TV", label: "Tuvalu" },
  { value: "UG", label: "Uganda" },
  { value: "UA", label: "Ukraine" },
  { value: "AE", label: "United Arab Emirates" },
  { value: "GB", label: "United Kingdom" },
  { value: "UY", label: "Uruguay" },
  { value: "UZ", label: "Uzbekistan" },
  { value: "VU", label: "Vanuatu" },
  { value: "VE", label: "Venezuela" },
  { value: "VN", label: "Vietnam" },
  { value: "YE", label: "Yemen" },
  { value: "ZM", label: "Zambia" },
  { value: "ZW", label: "Zimbabwe" },
];

const DialplanPermissionsAdd = () => {

  const navigate = useNavigate();
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";
  const { id } = useParams();

  const initialData = {
    group_name: "",
    assigned_ext: [],
    perm_cats: [],
    intl_countries: [],
    is_intercom: false, // new field
  };

  const [extensionList, setExtensionList] = useState([]);
  const [formData, setFormData] = useState(initialData);
  const [error, setError] = useState("");

  const permissionOptions = [
    {value: "internal", label: "Internal"},
    {value: "emergency", label: "Emergency"},
    {value: "canadausa", label: "Canada/US"},
    {value: "international", label: "International"},
  ];

  const isInternationalChecked =
    formData.perm_cats.includes("international");
  const isIntercom = formData.is_intercom;

  useEffect(() => {
    const fetchExtensions = async () => {
      try {
        const site = JSON.parse(localStorage.getItem("selectedSite"));
        const res = await fetch(`${serverHost}/get_extensions_full?domain_uuid=${site.site_uuid}`);
        if (!res.ok) return;
        const data = await res.json();
        const mapped = data.results.map((ext) => ({
          label: ext.extension,
          value: ext.extension_uuid,
        }));
        setExtensionList(mapped);
      } catch (err) {
        console.error("Failed to fetch extensions:", err);
      }
    };
    const fetchGroup = async () => {
      try {
        const res = await fetch(`${serverHost}/fetch_dp_perm/${id}`)
        if (!res.ok) {
            const err = await res.json()
            throw new Error(err.message || "Failed to fetch permission")
        }
        const data = await res.json() 
        setFormData(data.data)
      } catch (err) {
        console.error("Failed to fetch the group")
      }
    }
    console.log(id)
    fetchExtensions();

    if (id) {
      fetchGroup();
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (category) => {
    setFormData((prev) => {
      const exists = prev.perm_cats.includes(category);
      const updated = exists
        ? prev.perm_cats.filter((c) => c !== category)
        : [...prev.perm_cats, category];

      // Clear country selections when unchecking International
      return {
        ...prev,
        perm_cats: updated,
        ...(category === "International" && exists
          ? { intl_countries: [] }
          : {}),
      };
    });
  };

  const handleIntercomToggle = () => {
    setFormData((prev) => {
      const turningOn = !prev.is_intercom;
      return {
        ...prev,
        is_intercom: turningOn,
        // Force "Internal" only when turning on, restore empty when turning off
        perm_cats: turningOn ? ["Internal"] : [],
        intl_countries: turningOn ? [] : prev.intl_countries,
      };
    });
  };

  const handleSave = async () => {
    if (!formData.group_name) {
      setError("Please fill in all required fields.");
      return;
    }
    if (
      isInternationalChecked &&
      formData.intl_countries.length === 0
    ) {
      setError("Please select at least one country for International access.");
      return;
    }

    console.log("Saving:", formData);
    const site = JSON.parse(localStorage.getItem("selectedSite"));
    const user = JSON.parse(localStorage.getItem("user"));
    console.log(site)
    let url = `${serverHost}/add_permission/${site.site_uuid}`;
    if (id) url =  `${serverHost}/edit_permission/${id}`;

    const payload = {
      data: formData,
      insert_uuid: user?.user_uuid,
    }
    
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      })

      if (!res.ok) {
        throw new Error("Failed to insert permission!");
      }

      navigate("/admin/hucs/dialplan-permissions");
    } catch (err) {
      console.error(err)
    }
  };

  const handleBack = () => {
    const isDirty = Object.values(formData).some(
      (val) =>
        val !== "" && val !== null && !(Array.isArray(val) && val.length === 0),
    );
    if (!isDirty || window.confirm("Discard changes and go back?")) {
      navigate("/admin/hucs/dialplan-permissions");
    }
  };

  const labelStyle = {
    fontWeight: "bolder",
    color: isDark ? "#e2e8f0" : "#1e3a5f",
    marginBottom: "0.5rem",
  };

  return (
    <>
      <SimpleHeader name="Dialplan Permissions" parentName="HUCS" />

      <Container className="mt--6">
        <Card className="shadow-sm" style={{ marginTop: "-3rem" }}>
          <Card.Header
            style={{
              backgroundColor: isDark ? "#1f2937" : "#e9ecef",
              color: isDark ? "#e2e8f0" : "#1e3a5f",
              borderBottom: "none",
              padding: "1rem 1.5rem",
            }}
          >
            <h4 className="mb-0"> {id ? "EDIT" : "ADD"} PERMISSIONS</h4>
          </Card.Header>

          <Card.Body className="p-4">
            {error && <Alert variant="danger">{error}</Alert>}

            <Form>
              <Row>
                {/* Group Name */}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label style={labelStyle}>
                      Group Name <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="group_name"
                      value={formData.group_name}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                {/* Associated Extensions */}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label style={labelStyle}>
                      Associated Extensions{" "}
                    </Form.Label>
                    <HusariaSelect
                      isMulti
                      name="assigned_ext"
                      id="assigned_ext"
                      options={extensionList.map((ext) => ({
                        value: ext.value,
                        label: ext.label,
                      }))}
                      value={(formData.assigned_ext || [])
                        .map((extId) => {
                          const ext = extensionList.find(
                            (e) => e.value === extId,
                          );
                          return ext
                            ? { value: ext.value, label: ext.label }
                            : null;
                        })
                        .filter(Boolean)}
                      onChange={(selectedOptions) => {
                        const selectedIds = selectedOptions
                          ? selectedOptions.map((opt) => opt.value)
                          : [];
                        setFormData((prev) => ({
                          ...prev,
                          assigned_ext: selectedIds,
                        }));
                      }}
                      style={{ height: "46px" }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Intercom Toggle */}
              <Row className="mb-3">
                <Col md={12}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <Form.Check
                      type="switch"
                      id="is_intercom"
                      label={
                        <span style={{ ...labelStyle, marginBottom: 0 }}>
                          Intercom Only
                        </span>
                      }
                      checked={formData.is_intercom}
                      onChange={handleIntercomToggle}
                    />
                    {isIntercom && (
                      <span
                        style={{
                          fontSize: "0.75rem",
                          color: isDark ? "#93c5fd" : "#1d4ed8",
                          backgroundColor: isDark ? "#1e3a5f" : "#dbeafe",
                          padding: "2px 8px",
                          borderRadius: "4px",
                          fontWeight: 500,
                        }}
                      >
                        Locked to Internal
                      </span>
                    )}
                  </div>
                </Col>
              </Row>

              {/* Permission Categories */}
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label style={labelStyle}>
                      Permission Categories <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <div>
                      {permissionOptions.map((category) => (
                        <Form.Check
                          inline
                          key={category.value}
                          type="checkbox"
                          label={category.label}
                          checked={formData.perm_cats.includes(
                            category.value,
                          )}
                          onChange={() => handleCheckboxChange(category.value)}
                          disabled={isIntercom} // lock when intercom is on
                        />
                      ))}
                    </div>
                    {isIntercom && (
                      <small style={{ color: isDark ? "#9ca3af" : "#6b7280" }}>
                        Permission categories are locked while Intercom Only is
                        enabled.
                      </small>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              {/* International Countries — shown only when International is checked */}
              {isInternationalChecked && (
                <Row>
                  <Col md={8}>
                    <Form.Group className="mb-3">
                      <Form.Label style={labelStyle}>
                        International Countries{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>

                      {/* Region quick-select buttons */}
                      <div
                        className="mb-2"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "6px",
                        }}
                      >
                        {Object.entries(REGIONS).map(([region, codes]) => {
                          const allSelected = codes.every((c) =>
                            formData.intl_countries.includes(c),
                          );

                          return (
                            <Button
                              key={region}
                              size="sm"
                              variant={
                                allSelected ? "primary" : "outline-primary"
                              }
                              onClick={() => {
                                setFormData((prev) => {
                                  if (allSelected) {
                                    // Deselect all countries in this region
                                    return {
                                      ...prev,
                                      intl_countries:
                                        prev.intl_countries.filter(
                                          (c) => !codes.includes(c),
                                        ),
                                    };
                                  } else {
                                    // Add all countries in this region (avoid duplicates)
                                    const merged = Array.from(
                                      new Set([
                                        ...prev.intl_countries,
                                        ...codes,
                                      ]),
                                    );
                                    return {
                                      ...prev,
                                      intl_countries: merged,
                                    };
                                  }
                                });
                              }}
                            >
                              {allSelected ? "✓ " : "+ "}
                              {region}
                            </Button>
                          );
                        })}

                        {/* Clear all shortcut */}
                        {formData.intl_countries.length > 0 && (
                          <Button
                            size="sm"
                            variant="outline-danger"
                            onClick={() =>
                              setFormData((prev) => ({
                                ...prev,
                                intl_countries: [],
                              }))
                            }
                          >
                            Clear all
                          </Button>
                        )}
                      </div>

                      <HusariaSelect
                        isMulti
                        name="intl_countries"
                        id="intl_countries"
                        options={COUNTRIES}
                        value={COUNTRIES.filter((c) =>
                          formData.intl_countries.includes(c.value),
                        )}
                        onChange={(selectedOptions) => {
                          const selectedCodes = selectedOptions
                            ? selectedOptions.map((opt) => opt.value)
                            : [];
                          setFormData((prev) => ({
                            ...prev,
                            intl_countries: selectedCodes,
                          }));
                        }}
                        placeholder="Select countries..."
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}

              <div className="mt-4 d-flex justify-content-between">
                <Button variant="danger" onClick={handleBack}>
                  Cancel
                </Button>
                <Button
                  variant="success"
                  onClick={handleSave}
                  disabled={
                    !formData.group_name
                  }
                >
                  Save
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default DialplanPermissionsAdd;
